import { ApiResponse } from '@nf/types/api';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { useApiBackendInfo } from '../use-api-backend-info';
import { useQuery } from '@tanstack/react-query';
import queryKeys from '@/constants/query-keys';
import { useGetSiteConfigs } from '../use-site-configs';
import { ApiBackendInfo } from '../athena/types';
import { GetTicketGroupsRequest, TicketGroup } from './types';
import { mockTicketGroups } from './mock-data';

const isMockEnabled = false;

/**
 * 查詢指定用戶在特定日期區間內 (依據派獎日) 購買的彩券
 * @param apiBackendInfo 
 * @param request 包含開始日期和結束日期
 * @returns TicketGroup[] 彩券群組列表
 */
const fetchTicketGroups = async (apiBackendInfo: ApiBackendInfo, request: GetTicketGroupsRequest): Promise<ApiResponse<TicketGroup[]>> => {
	if (isMockEnabled) {
		return await mockTicketGroups();
	}
	const response = await fetchComposer.postWithBearer(`${apiBackendInfo.url}/GoldenDuel/GetTicketGroups`, {
		body: JSON.stringify(request)
	})(apiBackendInfo.token);

	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}
	return await response.json();
};

export const useTicketGroups = (request: GetTicketGroupsRequest) => {
	const { SiteConfigsData: siteConfig } = useGetSiteConfigs();
	const apiBackendInfo = useApiBackendInfo();

	return useQuery({
		queryKey: [
			queryKeys.GOLDEN_DUEL_TICKET_GROUPS,
			apiBackendInfo.url,
			JSON.stringify(request)
		],
		queryFn: () => fetchTicketGroups(apiBackendInfo, request),
		enabled: Boolean(siteConfig?.EnableGoldenDuel) && apiBackendInfo.isReady && !!request.startDate && !!request.endDate,
		cacheTime: 30 * 1000, // 30 seconds
		refetchOnWindowFocus: false
	});
};
